import Vue from 'vue';
import Vuex from 'vuex';
import persistedState from 'vuex-persistedstate';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  timeShowForWarehouse: false,
  noLoginPage: ['/admin/login'],
  menus: [],
  permissions: [],
  roles: [],
  currentMenu: {},
  homeMenu: '',
  userInfo: {},
  currentOpenMenu: '/transport',
  showSideNav: false,
  currentProjectId: window.localStorage.getItem('CURRENT_PROJECT_ID') || '',
  authUrlList: {},
  globalEnumCollection: {
    accountStatusEnum: {
      0: '已禁用',
      1: '正常',
      2: '已删除',
    },
    accountTypeEnum: {
      10: '超级管理员',
      20: '企业用户',
      21: '站点用户',
      22: 'APP终端用户',
      30: '工厂用户',
      // 40: '设备用户',
    },
    accountTypeEnumByAdmin: {
      20: '企业用户',
      21: '站点用户',
      22: 'APP终端用户',
      30: '工厂用户',
    },
    accountTypeEnumByCompany: {
      21: '站点用户',
      22: 'APP终端用户',
    },
    accountTypeEnumByStation: {
      22: 'APP终端用户',
    },
    wareHouseTypeEnum: {
      1: '制冷库',
      2: '常温库',
    },
    onlineFlagEnum: {
      0: '离线',
      1: '在线',
    },
    deviceTypeEnum: {
      0: '直连',
      1: '节点',
      2: '网关',
      3: '蓝牙',
    },
    alarmTypeEnum: {
      1: '温度超限',
      2: '湿度超限',
      3: '低电',
      4: '断电',
      5: '离线',
      6: '振动',
      7: '倾斜',
      8: '光照',
      9: '温度预警',
      10: '湿度预警',
      11: '温度2超限',
      12: '温度3超限',
      13: '湿度2超限',
      14: '湿度3超限',
      15: '温度2预警',
      16: '温度3预警',
      17: '湿度2预警',
      18: '湿度3预警',
    },
    alarmExecutorTypeEnum: {
      1: '短信',
      2: '邮件',
      3: '微信公众号',
      4: '语音',
    },
    readStatusEnum: {
      0: '未阅',
      1: '已阅',
    },
    recoverStatusEnum: {
      0: '未恢复',
      1: '已恢复',
    },
    locationAreaEnum: {
      1: '预冷区',
      2: '释冷区',
      3: '打包区',
      4: '回收区',
    },
    iceBoxProcessStatusEnum: {
      0: '总冰盒',
      1: '待预冷',
      2: '预冷中',
      3: '预冷完成',
      4: '释冷中',
      5: '释冷完成',
      6: '释冷过久',
      7: '运输中',
      8: '运输完成',
    },
    iceBoxProcessStatusWithoutSiteEnum: {
      1: '待预冷',
      2: '预冷中',
      3: '预冷完成',
      4: '释冷中',
      5: '释冷完成',
      6: '释冷过久',
    },
    transportStatusEnum: {
      0: '待运输',
      1: '运输中',
      2: '运输完成',
      3: '取消运输',
    },
    sendParamStatusEnum: {
      0: '未下发',
      1: '下发中',
      2: '下发完成',
    },
    shutdownStatusEnum: {
      0: '未操作',
      1: '关机中',
      2: '关机成功',
    },
    boxStatusEnum: {
      1: '可用',
      2: '在运',
      3: '待回收',
    },
    boxRecycleStatusEnum: {
      0: '未回收',
      1: '已回收',
    },
    iceBoxRecycleStatusEnum: {
      0: '未回收',
      1: '已回收',
    },
    deviceRecycleStatusEnum: {
      0: '未回收',
      1: '已回收',
    },
    tempStatusEnum: {
      1: '正常',
      2: '超温',
    },
    resultEnum: {
      0: '失败',
      1: '成功',
    },
    assetTypeEnum: {
      0: '箱子',
      1: '冰盒',
      2: '记录仪',
      3: '冰盒架',
      4: '冰盒托盘',
      5: '冰盒筐',
      6: '方仓',
      7: '移动冷库',
      8: '车辆',
    },
    assetCodeTypeEnum: {
      0: '仓库',
      1: '库位',
      2: '冰箱',
      3: '保温箱',
      13: '方仓',
      14: '移动冷库',
      15: '车辆',
    },
    operateTypeEnum: {
      1: '入库',
      2: '出库',
      3: '打包',
      4: '回收',
      5: '解绑',
    },
    // 冰盒出入库的载体类型
    carrierTypeEnum: {
      1: '冰盒架',
      2: '冰盒托盘',
      3: '筐',
      4: '/',
    },
    // GPS开关
    gpsSwitchEnum: {
      0: '关闭',
      1: '开启',
    },
    // 亮屏时间
    brightScreenEnum: {
      0: '常亮',
      1: '15秒',
      2: '30秒',
      10: '1分钟',
      20: '2分钟',
      30: '3分钟',
      40: '4分钟',
      50: '5分钟',
    },
    // 设备事件
    deviceEventEnum: {
      0: '开机',
      1: '关机',
      2: '重启',
      3: '断开电源',
      4: '连接电源',
      5: '开箱',
      6: '关箱',
      7: '短信下发参数',
      8: '平台下发参数',
      9: '进入飞行模式',
      10: '退出飞行模式',
      11: '振动',
      12: '振动恢复',
      13: '倾斜',
      14: '倾斜恢复',
      15: '光照',
      16: '光照恢复',
    },
    // 短信充值
    smsRechargeEnum: {
      1: '充值',
      2: '返还',
    },
    // 导出类型
    exportTypeEnum: {
      1: '数据列表',
      2: '数据报告',
      3: '告警记录',
      4: '批量列表',
      5: '设备列表',
    },
    assetStatusEnum: {
      0: '禁用',
      1: '启用',
    },
    carTypeEnum: {
      1: '常温车',
      2: '冷藏车',
      3: '冷冻车',
    },
    exportResultEnum: {
      0: '生成中',
      1: '已生成',
      2: '生成失败',
    },
    deviceServiceStatusEnum: {
      0: '正常',
      1: '已过期',
    },
    menuUserTypeEnum: {
      1: '后台',
    },
    menuTypeEnum: {
      1: '目录',
      2: '菜单',
      3: '按钮',
    },
    whetherEnum: {
      0: '否',
      1: '是',
    },
    statusEnum: {
      0: '禁用',
      1: '启用',
    },
    deviceStatusEnum: {
      0: '禁用',
      1: '启用',
      2: '损坏',
    },
    weekEnum: {
      1: '周一',
      2: '周二',
      3: '周三',
      4: '周四',
      5: '周五',
      6: '周六',
      7: '周日',
    },
    deviceShipmentStatusEnum: {
      0: '发运结束',
      1: '发运中',
      2: '未发运',
    },
    ordersStatusEnum: {
      0: '待付款',
      1: '已付款',
      2: '已取消',
      3: '支付失败',
      4: '待收货',
      5: '已完成',
      6: '已退款',
    },
  },
  menuList: [
  ],
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  strict: process.env.NODE_ENV !== 'production',
  plugins: [persistedState({ storage: window.sessionStorage })],
});



// WEBPACK FOOTER //
// ./src/store/index.js